<template>
  <section class="w3l-footer">
    <v-footer dark padless>
      <v-card class="flex div-lang-footer white--text text-center" flat tile>
        <v-card-title class="div-lang-footer white--text text-center">
          <v-container>
            <div class="row row--dense">
              <div class="col-sm-6 col-lg-4 col-12">
                <div
                  class="
                    overflow-hidden
                    theme--light
                    v-sheet v-sheet--outlined
                    rounded
                  "
                  min-height="40"
                  style="min-height: 40px"
                >
                  <div
                    class="v-list-item v-list-item--link theme--light"
                    tabindex="0"
                  >
                    <div class="v-list-item__icon">
                      <span
                        aria-hidden="true"
                        class="
                          v-icon
                          notranslate
                          theme--light
                          indigo--text
                          text--darken-1
                        "
                      >
                        <v-list-item-avatar>
                          <v-btn id="lang-btn" text class="white--text">
                            <flag iso="ci" class="white-text" />
                          </v-btn>
                        </v-list-item-avatar>
                      </span>
                    </div>
                    <div class="v-list-item__content">
                      <div class="v-list-item__subtitle">
                        ambinshasa@yahoo.frttons
                      </div>
                      <div class="v-list-item__title">
                        <i class="fa fa-phone m-2"></i>
                        (00 255) 07 89 89 63 44
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-6 col-lg-4 col-12">
                <div
                  class="
                    overflow-hidden
                    theme--light
                    v-sheet v-sheet--outlined
                    rounded
                  "
                  min-height="40"
                  style="min-height: 40px"
                >
                  <div
                    class="v-list-item v-list-item--link theme--light"
                    tabindex="0"
                  >
                    <div class="v-list-item__icon">
                      <span
                        aria-hidden="true"
                        class="
                          v-icon
                          notranslate
                          theme--light
                          indigo--text
                          text--darken-1
                        "
                      >
                        <v-list-item-avatar>
                          <v-btn id="lang-btn" text class="white--text">
                            <flag
                              iso="bj"
                              class="white-text"
                              :class="['m-2']"
                            />
                          </v-btn>
                        </v-list-item-avatar>
                      </span>
                    </div>
                    <div class="v-list-item__content">
                      <div class="v-list-item__subtitle">
                        dsdsndsn@yahoo.frttons
                      </div>
                      <div class="v-list-item__title">
                        <i class="fa fa-phone m-2"></i>
                        (00 229) 62 00 09 44
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-6 col-lg-4 col-12">
                <div
                  class="
                    overflow-hidden
                    theme--light
                    v-sheet v-sheet--outlined
                    rounded
                  "
                  min-height="40"
                  style="min-height: 40px"
                >
                  <div
                    class="v-list-item v-list-item--link theme--light"
                    tabindex="0"
                  >
                    <div class="v-list-item__icon">
                      <span
                        aria-hidden="true"
                        class="
                          v-icon
                          notranslate
                          theme--light
                          indigo--text
                          text--darken-1
                        "
                      >
                        <v-list-item-avatar>
                          <v-btn id="lang-btn" text class="white--text">
                            <flag iso="tg" class="white-text" />
                          </v-btn>
                        </v-list-item-avatar>
                      </span>
                    </div>
                    <div class="v-list-item__content">
                      <div class="v-list-item__subtitle">
                        burkina@yahoo.frttons
                      </div>
                      <div class="v-list-item__title">
                        <i class="fa fa-phone m-2"></i>
                        (00 228) 89 89 63 44
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-container>
        </v-card-title>

        <v-card-text class="py-2 white--text text-center">
          © Copyright 2022 
          <!-- <strong>ITSS</strong> -->
        </v-card-text>
      </v-card>
    </v-footer>

    <button onclick="topFunction()" id="movetop" title="Go to top">
      <span class="fa fa-angle-up"></span>
    </button>
    <!-- move top -->
  </section>
</template>

<script>
export default {
  data() {
    return {
      icons: ["mdi-facebook", "mdi-twitter", "mdi-linkedin", "mdi-instagram"],
    };
  },
};
</script>

<style lang="scss" scoped>
.div-lang-footer {
  background-color: rgb(37, 51, 114) !important;
}
.contact-footer {
  color: #fff;
  background-color: #253372;
}
.v-list-item {
  background-color: rgba(37, 51, 114, 0.6) !important;
}

.v-list-item__avatar {
  -ms-flex-item-align: center;
  align-self: center;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: center !important;
}

#lang-btn {
  border: none;
  outline: none;
  font-size: 50px;
  border-radius: 50px;
}
@media (max-width: 700px) {
  #copyright {
    height: 80px;
  }
}
</style>
